// ═══════════════════════════════════════════════════════
// Copy for each step of the planner
// ═══════════════════════════════════════════════════════

export const stepCopy = {
  destination: {
    heading: "Where do you want to go?",
    sub: "Pick a destination. We'll plan everything around it.",
  },
  dates: {
    heading: () => `When are you going?`,
    sub: "Pick your dates and we'll build the itinerary around them.",
  },
  flights: {
    heading: (city) => `Let's lock in your flights to ${city}`,
    sub: "Compare options and pick the redemption that gives you the best value.",
  },
  hotel: {
    heading: (city) => `Where do you want to stay in ${city}?`,
    sub: "Hotel points are easiest via Chase UR → Hyatt. Cash is fine too.",
  },
  activities: {
    heading: (city) => `Things to do in ${city}`,
    sub: "Pick what you want to do. We'll keep tabs on the cost.",
  },
  food: {
    heading: () => "Where to eat",
    sub: "Pick a few spots worth planning around.",
  },
  review: {
    heading: (city) => `Your ${city} plan`,
    sub: "Review everything below, then book.",
  },
};

// ── Chat suggestions ──
export const chatSuggestions = [
  "What's the best destination for adventure + great food?",
  "Should I use Iberia Avios or Aeroplan for Spain?",
  "How should I split my Amex and Chase points?",
  "Is it worth waiting for a transfer bonus?",
  "Compare Croatia vs Portugal for September",
  "Walk me through booking with Aeroplan step by step",
];

export const aiTipLabel = "Tip";
